import { TFunction } from 'react-i18next';

import { Campaign } from '@dev/ee-api/ee-api-models';
import { palette, SimplePopoverPlainOption } from '@dev/ee-components';
import { DropdownOptions } from '@/store/campaigns/types';
import { isCancelCampaignPossible, isReactivateCampaignAvailable } from '..';

export const getDropdownTableOptions = (
    campaign: Campaign,
    isMobile: boolean,
    t: TFunction
): SimplePopoverPlainOption[] => [
    ...(isMobile
        ? [
              {
                  label: t('viewdetails'),
                  value: DropdownOptions.ViewDetails,
              },
          ]
        : []),
    {
        label: t('edit'),
        value: DropdownOptions.Edit,
    },
    ...(isCancelCampaignPossible(campaign)
        ? [
              {
                  label: t('pause'),
                  value: DropdownOptions.Pause,
              },
          ]
        : []),
    ...(isReactivateCampaignAvailable(campaign)
        ? [
              {
                  label: t('reactivate'),
                  value: DropdownOptions.Reactivate,
              },
          ]
        : []),
    {
        label: t('copycampaign'),
        value: DropdownOptions.CopyCampaign,
    },
    {
        label: t('delete'),
        color: palette.red[6],
        value: DropdownOptions.Delete,
    },
];
